import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css'],
})
export class PrivacyPolicyComponent implements OnInit {
  public user: any;
  constructor() {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.user == null) this.user = { role: 'OutSideOrg' };
  }
}
